import React from 'react';
import { Hero } from '../components/Hero';
import { ProductServices } from '../components/ProductServices';
import { GangSheetBuilder } from '../components/GangSheetBuilder';
import { ScreenPrintingTeaser } from '../components/ScreenPrintingTeaser';
import { WhyPrintAtomic } from '../components/WhyPrintAtomic';
import { ProcessSection } from '../components/ProcessSection';
import { WhoWeAreFor } from '../components/WhoWeAreFor';
import { CTABand } from '../components/CTABand';
import { Testimonials } from '../components/Testimonials';
export function Home() {
  return <main data-id="element-1136">
      <Hero data-id="element-1137" />
      <div id="services" data-id="element-1138">
        <ProductServices data-id="element-1139" />
      </div>
      <GangSheetBuilder data-id="element-1140" />
      <ScreenPrintingTeaser data-id="element-1141" />
      <WhyPrintAtomic data-id="element-1142" />
      <Testimonials data-id="element-1143" />
      <ProcessSection data-id="element-1144" />
      <WhoWeAreFor data-id="element-1145" />
      <CTABand data-id="element-1146" />
    </main>;
}